var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181_736)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M4.0625 12.7969V3.04688C4.0625 2.10041 4.70986 1.30513 5.58594 1.07961C5.42004 1.03699 5.24941 1.01549 5.07812 1.01563H3.04688C1.92507 1.01563 1.01562 1.92507 1.01562 3.04688V12.7969C1.01562 13.9187 1.92507 14.8281 3.04688 14.8281H5.07812C5.25347 14.8281 5.42364 14.8059 5.58594 14.7641C4.70986 14.5386 4.0625 13.7433 4.0625 12.7969Z",
    fill: "url(#paint0_linear_181_736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07812 14.8281H3.04688C1.92507 14.8281 1.01562 13.9187 1.01562 12.7969V3.04688C1.01562 1.92507 1.92507 1.01562 3.04688 1.01562H5.07812C6.19993 1.01562 7.10938 1.92507 7.10938 3.04688V12.7969C7.10938 13.9187 6.19993 14.8281 5.07812 14.8281ZM12.7969 24.9844H3.04688C1.92507 24.9844 1.01562 24.0749 1.01562 22.9531V20.9219C1.01562 19.8001 1.92507 18.8906 3.04688 18.8906H12.7969C13.9187 18.8906 14.8281 19.8001 14.8281 20.9219V22.9531C14.8281 24.0749 13.9187 24.9844 12.7969 24.9844ZM22.9531 24.9844H20.9219C19.8001 24.9844 18.8906 24.0749 18.8906 22.9531V20.9219C18.8906 19.8001 19.8001 18.8906 20.9219 18.8906H22.9531C24.0749 18.8906 24.9844 19.8001 24.9844 20.9219V22.9531C24.9844 24.0749 24.0749 24.9844 22.9531 24.9844Z",
    stroke: "url(#paint1_linear_181_736)",
    strokeWidth: 2.04286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9531 14.8281H13.2031C12.0813 14.8281 11.1719 13.9187 11.1719 12.7969V3.04688C11.1719 1.92507 12.0813 1.01562 13.2031 1.01562H22.9531C24.0749 1.01562 24.9844 1.92507 24.9844 3.04688V12.7969C24.9844 13.9187 24.0749 14.8281 22.9531 14.8281Z",
    stroke: "black",
    strokeWidth: 2.04286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181_736",
    x1: 1.01562,
    y1: 1.01562,
    x2: 10.0113,
    y2: 5.11341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_181_736",
    x1: 1.44445,
    y1: -1.67943,
    x2: 29.1602,
    y2: 24.3093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWhite);
export default __webpack_public_path__ + "static/media/dashboardWhite.a030386a79ecee77405463703104688a.svg";
export { ForwardRef as ReactComponent };